<template lang="pug">
  .blog-social-networks
    .social-section
      share-network(network="facebook" :url="contentUrl" :title="title")
        span.social-icons.facebook-icon.max-at-tweak Share
      share-network(network="twitter" :url="contentUrl" :title="title" twitter-user="madisonreedllb")
        span.social-icons.twitter-icon.max-at-tweak Tweet
      share-network(network="pinterest" :url="contentUrl" :title="title" :media="contentImageUrl")
        span.social-icons.pinterest-icon.max-at-tweak Pin
      a(:href="emailHref")
        span.social-icons.email-icon.max-at-tweak Email
</template>

<script>
export default {
  name: "BlogSocialNetworks",
  props: {
    contentUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    contentImageUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    emailHref() {
      return `mailto:?subject=Madison Reed - ${this.title}&body=${this.title} ${this.contentUrl} via Madison Reed`;
    }
  }
};
</script>

<style lang="stylus">
.social-section
  margin-top 10px
  margin-bottom 5px

  @media mq-mobile
    margin-top 5%
    margin-bottom 6%

  .social-icons
    display inline-block
    width 22.5%
    height 2.5em
    font-family fontello !important
    border 1.5px solid #ffffff
    color #ffffff
    padding 0.4em
    text-align center
    margin-right 1.5%
    font-size 1em

    &:before
      margin-right 0.3em

  .email-icon
    border 1.5px solid text-color-2
    color text-color-2

    &:before
      content icon-email !important

  .facebook-icon
    background-color #3b5998
    border 1.5px solid #3b5998

    &:before
      content icon-facebook !important

  .twitter-icon
    background-color #55acee
    border 1.5px solid #55acee

    &:before
      content icon-twitter !important

  .pinterest-icon
    background-color #c92228
    border 1.5px solid #c92228

    &:before
      content icon-pinterest !important
</style>
